/**
 * MyClaims.js
 *
 * This file contains all the route under My claims
 */

import View from '@/components/componentView.vue';
import { MY_CLAIMS_PAGES } from '@/constants/pageTitles';
import { deviceType } from '@/utils';
import { DeviceTypes } from '@/enums';
import BenefitQuotesAndClaims from '../views/BenefitQuotesAndClaims/BenefitQuotesAndClaims.vue';
import GABQnMANC from '../views/BenefitQuotesAndClaims/GABQnMANC.vue';
import SnapAndSend from '../views/BenefitQuotesAndClaims/SnapAndSend.vue';
import QuoteResultClaimSubmission from '../views/BenefitQuotesAndClaims/QuoteResultClaimSubmission.vue';
import ClaimResultSubmissionKeepPrivate from '../views/BenefitQuotesAndClaims/ClaimResultSubmissionKeepPrivate.vue';
import LimitsUsage from '../views/MyClaims/LimitsUsage/LimitsUsage.vue';
import SnapAndSendSubmission from '../views/BenefitQuotesAndClaims/SnapAndSendSubmission.vue';
import {
  HOME,
  BENEFIT_QUOTE_QUOTES,
  BENEFIT_QUOTE_GET_A_BENEFIT,
  BENEFIT_QUOTE_RESULT,
  CLAIMS,
  CLAIMS_MAKE_A_CLAIM,
  CLAIMS_RESULT,
  CLAIMS_RESULT_KEEP_PRIVATE,
  SNAP_AND_SEND,
  SNAP_AND_SEND_RESULT,
  ERROR_404_PAGE_NOT_FOUND,
} from './routeNames';

export default [
  {
    path: 'my-claims',
    component: View,
    meta: {
      title: 'My claims',
      isCategory: true,
    },
    children: [
      {
        path: '',
        redirect: {
          name: HOME,
        },
      },
      {
        path: 'benefit-quotes',
        component: View,
        meta: {
          title: MY_CLAIMS_PAGES.BENEFIT_QUOTES.LANDING,
        },
        children: [
          {
            path: '',
            name: BENEFIT_QUOTE_QUOTES,
            component: BenefitQuotesAndClaims,
            meta: {
              title: MY_CLAIMS_PAGES.BENEFIT_QUOTES.LANDING,
            },
          },
          {
            path: 'get-a-benefit-quote',
            name: BENEFIT_QUOTE_GET_A_BENEFIT,
            component: GABQnMANC,
            meta: {
              title: MY_CLAIMS_PAGES.BENEFIT_QUOTES.GET_A_BENEFIT_QUOTE,
            },
          },
          {
            path: ':accessingPersonCode-:quoteId',
            name: BENEFIT_QUOTE_RESULT,
            component: QuoteResultClaimSubmission,
            beforeEnter: (to) => {
              to.meta.title = `${MY_CLAIMS_PAGES.BENEFIT_QUOTES.RESULT}${to.params.quoteId?.toUpperCase()}`;
            },
          },
        ],
      },
      {
        path: 'claims',
        component: View,
        meta: {
          title: MY_CLAIMS_PAGES.CLAIMS.LANDING,
        },
        children: [
          {
            path: '',
            name: CLAIMS,
            component: BenefitQuotesAndClaims,
            meta: {
              title: MY_CLAIMS_PAGES.CLAIMS.LANDING,
            },
            props: {
              isClaim: true,
            },
          },
          {
            path: 'make-a-claim',
            name: CLAIMS_MAKE_A_CLAIM,
            component: GABQnMANC,
            meta: {
              title: MY_CLAIMS_PAGES.CLAIMS.MAKE_A_CLAIM,
            },
            props: {
              isClaim: true,
            },
          },
          {
            path: 'claim-keep-private',
            name: CLAIMS_RESULT_KEEP_PRIVATE,
            component: ClaimResultSubmissionKeepPrivate,
            beforeEnter: (to) => {
              to.meta.title = `${MY_CLAIMS_PAGES.CLAIMS.RESULT_KEEP_PRIVATE}`;
            },
          },
          {
            path: ':accessingPersonCode-:quoteId',
            name: CLAIMS_RESULT,
            component: QuoteResultClaimSubmission,
            beforeEnter: (to) => {
              to.meta.title = `${MY_CLAIMS_PAGES.CLAIMS.RESULT}${to.params.quoteId?.toUpperCase()}`;
            },
            props: {
              isClaim: true,
            },
          },
        ],
      },
      {
        path: 'limits-and-usage',
        component: LimitsUsage,
        meta: {
          title: MY_CLAIMS_PAGES.LIMITS_USAGE.LANDING,
        },
      },
      {
        path: 'snap-and-send',
        component: View,
        meta: {
          title: MY_CLAIMS_PAGES.SNAP_AND_SEND.LANDING,
        },
        children: [
          {
            path: '',
            name: SNAP_AND_SEND,
            component: SnapAndSend,
            meta: {
              title: MY_CLAIMS_PAGES.SNAP_AND_SEND.LANDING,
            },
            beforeEnter: () => {
              const currentDevice = deviceType();
              if (currentDevice === DeviceTypes.DESKTOP) {
                return { name: ERROR_404_PAGE_NOT_FOUND };
              }
            },
          },
          {
            path: 'snap-and-send-result',
            name: SNAP_AND_SEND_RESULT,
            component: SnapAndSendSubmission,
            beforeEnter: (to) => {
              to.meta.title = `${MY_CLAIMS_PAGES.SNAP_AND_SEND.RESULT}`;
            },
          },
        ],
      },
    ],
  },
];
